import {createAction, props} from '@ngrx/store';
import {ProjectCreateDTO, ProjectDTO} from '../dto/project';

export const loadProjects = createAction('[Project] Load Projects');
export const loadProjectsSuccess = createAction(
  '[Project] Load Projects Success',
  props<{ projects: ProjectDTO[] }>()
);
export const loadProjectsFailure = createAction(
  '[Project] Load Projects Failure',
  props<{ error: any }>()
);

export const loadExploreProjects = createAction('[Project-Explore] Load Projects');
export const loadExploreProjectsSuccess = createAction(
  '[Project-Explore] Load Projects Success',
  props<{ projects: ProjectDTO[] }>()
);
export const loadExploreProjectsFailure = createAction(
  '[Project-Explore] Load Projects Failure',
  props<{ error: any }>()
);


export const createProject = createAction(
  '[Project] Create Project',
  props<{ project: ProjectCreateDTO }>()
);
export const createProjectSuccess = createAction(
  '[Project] Create Project Success',
  props<{ project: ProjectDTO }>()
);
export const createProjectFailure = createAction(
  '[Project] Create Project Failure',
  props<{ error: any }>()
);

export const updateProject = createAction(
  '[Project] Update Project',
  props<{ id: number; project: ProjectDTO }>()
);
export const updateProjectSuccess = createAction(
  '[Project] Update Project Success',
  props<{ project: ProjectDTO }>()
);
export const updateProjectFailure = createAction(
  '[Project] Update Project Failure',
  props<{ error: any }>()
);

export const deleteProject = createAction(
  '[Project] Delete Project',
  props<{ id: number }>()
);
export const deleteProjectSuccess = createAction(
  '[Project] Delete Project Success',
  props<{ id: number }>()
);
export const deleteProjectFailure = createAction(
  '[Project] Delete Project Failure',
  props<{ error: any }>()
);

export const retrieveProject = createAction(
  '[Project] Retrieve Project',
  props<{ id: number }>()
);
export const retrieveProjectSuccess = createAction(
  '[Project] Retrieve Project Success',
  props<{ project: ProjectDTO }>()
);
export const retrieveProjectFailure = createAction(
  '[Project] Retrieve Project Failure',
  props<{ error: any }>()
);
